var levelOfAWSUsage = {
	"Level of AWS usage": "AWS 使用量レベル",
	"Do not use AWS today": "現在は AWS を使用していない",
	"Evaluating/experimenting with AWS": "AWS を評価中または試験中",
	"Run dev/test workloads on AWS": "AWS で開発/テストワークロードを実行",
	"Run a production workload on AWS": "AWS でプロダクションワークロードを実行",
	"Run multiple production workloads on AWS": "AWS で複数のプロダクションワークロードを実行"
};

export { levelOfAWSUsage as default };
